export function getActionButton(actions, actionType) {
  return actions === null || actions === void 0 ? void 0 : actions.find(function (action) {
    return action.type === actionType;
  });
}